import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { SatisfactionService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';

@Component({
    'selector': 'app-satisfaction2',
    'templateUrl': 'satisfactionPage2.page.html',
    'styleUrls': ['./satisfactionPage2.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class SatisfactionPage2 extends ViewBasePage implements OnInit {
    // If the user forgets to set the slider, then don't count his score.  (7 and 8 is passive)
    public vm = {
        'nps': 8,
        'question2': 'What do we need to do to earn a score of 10?',
        'answer2': '',
        'question3': 'What do you like about ShuttleNomix?',
        'answer3': ''
    };

    constructor(private satisfactionService: SatisfactionService,  injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_SATISFACTION_PAGE2);
    }

    public override ngOnInit(): void {
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-satisfaction-2-tour');
    }

    // if nps = 0-6  then question = What are the primary reasons you gave this score?
    // if nps = 7,8  then question = What do we need to do to earn a score of 10?
    // if nps = 9,10 then question = What do you like about Shlepz?
    // Ask different questions based on how they score.
    public onNpsChange() {
        const nps = this.vm.nps;

        if (nps >= 0 && nps <= 6) {
            this.vm.question2 = 'What are the primary reasons you gave this score?';
            this.vm.question3 = 'Would you be willing to discuss our shortcomings over the phone?';
        } else if (nps >= 7 && nps <= 8) {
            this.vm.question2 = 'What do we need to do to earn a score of 10?';
            this.vm.question3 = 'If we improved on the items you mentioned, would you be willing to change your score?';
        } else if (nps >= 9 && nps <= 10) {
            this.vm.question2 = 'What do you like about ShuttleNomix?';
            this.vm.question3 = 'Would you be willing to offer a testimonial?';
        }
    }

    public async onSaveClick() {
        try {
            await this.uxHelperService.showSpinner('Saving.');
            await this.satisfactionService.add(this.vm);
            this.uxHelperService.showToast('Saved.  Thank you.');
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error:', errorMessage);
        } finally {
            this.router.navigateByUrl('/help');
            await this.uxHelperService.hideSpinner();
        }
    }
}
